import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const branchLocaleModule: LocaleModule = {
  name: "branch",
  messages: { en: en, it: it },
};
